import images from "../constants/images";

const getBrandIcon = (brand?: string | null) => {
	switch (brand?.toLowerCase()) {
		case 'visa':
			return images.visaBrand;
		case 'mastercard':
			return images.masterBrand;
		case 'amex':
			return images.amexBrand;
		default:
			return undefined;
	}
};

export {
  getBrandIcon,
};
